export default theme => ({
  journalRoot: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    height: '100%',
    minHeight: 250,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.dark,
    '& .scroller': {
      flexGrow: 1,
      flexBasis: '100%',
    },
    '& [role="button"], & a[href], & li:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.contrast.enabled}`,
    },
  },
  loading: {
    marginTop: 25,
    textAlign: 'center',
  },
  icon: {
    marginRight: 0,
  },
  iconDanger: {
    color: theme.palette.error.notification,
  },
  card: {
    backgroundColor: theme.palette.background.dark,
    borderBottom: `1px solid ${theme.palette.contrast.enabled}`,
    height: 72,
    '&:hover, &$activeCard': {
      backgroundColor: theme.palette.primary.active,
      cursor: 'pointer',
    },
  },
  room: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    color: theme.palette.text.inactive,
  },
  activeCard: {},
  title: {
    color: theme.palette.text.primary,
  },
  secondary: {
    color: theme.palette.text.inactive,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  subheader: {
    ...theme.typography.h6,
    display: 'block',
    flex: `0 0 ${theme.spacing(6)}`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'default !important',
    '&:hover': {
      backgroundColor: theme.palette.background.dark,
    },
  },
  list: {
    display: 'block',
    flex: 1,
    minHeight: `calc(100% - ${theme.spacing(6)})`,
    maxHeight: '100%',
  }
})
